import React from 'react';
import '../styles/index.css';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { Badge } from 'react-bootstrap';
import ToggleSwitch from '../../common/utils/toggle-switch';

function UserRoleDataTable({ columns, data, isSwitching, handleEnableDisable }) {

  return (
    <div className='datatable border h-auto rounded'>
      <table className='table mb-0'>
        <thead className='table-head'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 ? 'ps-5 bg-light' : index === columns.length - 1 ? 'pe-5 bg-light' : 'p-3 bg-light'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((tb_items, index) => {
                  return (
                    <tr key={index}>
                      <td className='ps-5 align-middle'>{index + 1}</td>
                      <td className="align-middle">{tb_items.displayName}</td>
                      <td className="align-middle">{tb_items.email}</td>
                      <td className="align-middle">
                        <Badge bg={tb_items.emailVerified ? 'success' : 'danger'}>
                          {tb_items.emailVerified ? 'Verified' : 'Not Verified'}
                        </Badge>
                      </td>
                      <td className="align-middle">{tb_items.customClaims && tb_items.customClaims.role}</td>
                      <td className='d-flex align-items-center justify-content-end'>
                        {
                          tb_items.customClaims && tb_items.customClaims.role === "admin" ?
                            <ToggleSwitch
                              disabled={true}
                              isLoading={isSwitching === tb_items.uid}
                              checked={tb_items.disabled ? false : true}
                              onChange={() => null}
                            />
                            :
                            <ToggleSwitch
                              isLoading={isSwitching === tb_items.uid}
                              checked={tb_items.disabled ? false : true}
                              onChange={() => handleEnableDisable(tb_items.uid, tb_items.disabled ? false : true)}
                            />
                        }
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={7}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No User Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default UserRoleDataTable;
